var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"border"}),_c('h1',[_vm._v("Get In Touch")]),_c('p',[_vm._v(" My inbox is always open. Whether you have a question or just want to say hi, I’ll try my best to get back to you! ")]),_c('a',{attrs:{"href":"mailto:soboleskijoe@gmail.com"}},[_vm._v("Send me a message!")]),_c('div',{staticClass:"border"})])
}]

export { render, staticRenderFns }